import React from "react";

import { enterNativeFullscreen, useVideoElement } from "./useVideoElement";

export function FullScreenButton(props: { playerId: string }) {
	const { playerId } = props;
	const getVideo = useVideoElement(playerId);

	const handleClick = () => {
		enterNativeFullscreen(getVideo());
	};

	return (
		<button
			type="button"
			className="widget__btn btn btn--square btn--square--sml btn--secondary widget--ls__btn"
			onClick={handleClick}
		>
			<i className="u-icon u-icon--sml u-icon--video-full" />
		</button>
	);
}
